module.exports = __webpack_public_path__ + "img/medium_blonde.808b522d.svg";